import { FunctionComponent, PropsWithChildren } from 'react';

export interface ISimpleTableProps {
  paginationComponent?: JSX.Element;
  columnDropdownComponent?: JSX.Element;
}

/**
 * @deprecated This component is deprecated and should not be used in new code.
 * Please migrate to the new component.
 * @link src/lib/Tables/FrontTable/FrontTable.tsx
 */
const SimpleTable: FunctionComponent<PropsWithChildren<ISimpleTableProps>> = ({ children, columnDropdownComponent, paginationComponent }) => {
  return (
    <div className='flex flex-col'>
      <div className='flex justify-end'>{columnDropdownComponent}</div>
      <div className='inline-block min-w-full py-2 align-middle'>
        <div className='border-grey-200 h-auto overflow-y-auto rounded-md border shadow-md'>
          <div className='overflow-x-auto'>
            <table className='min-w-full table-auto border-collapse'>{children}</table>
          </div>
          {paginationComponent}
        </div>
      </div>
    </div>
  );
};

export default SimpleTable;
